import axios from 'axios';

const REACT_APP_API_URL = "https://api.max-photo.uz/api"

export const request = axios.create({
  baseURL: REACT_APP_API_URL,
});
